module.exports = __webpack_public_path__ + "static/img/icon_yw_active.0f875950.svg";